export default __webpack_public_path__ + "static/media/tokenomics-hero.7dd7963d.png";